export class StorageWrapper {
  private readonly storage?: Storage;

  static create(callback: () => Storage | undefined | null) {
    try {
      return new StorageWrapper(callback() || undefined);
    } catch (e) {
      window.console.warn('Uncaught error:', e);

      return new StorageWrapper();
    }
  }

  constructor(storage?: Storage) {
    this.storage = storage;
  }

  tryClear(): boolean {
    try {
      if (!this.storage) return false;

      this.storage.clear();

      return true;
    } catch (e) {
      window.console.warn('Uncaught: setItem error:', e);

      return false;
    }
  }

  trySetItem(key: string, value?: string): boolean {
    if (!this.storage || !value) return false;

    try {
      this.storage.setItem(key, value);

      return true;
    } catch (e) {
      window.console.warn('Uncaught: setItem error:', e);

      return false;
    }
  }

  trySetJSONItem(key: string, value: object | any[]): boolean {
    let valueStr: string;

    try {
      valueStr = JSON.stringify(value);
    } catch (e) {
      window.console.warn('Failed to stringify value in trySetJSONItem:', e);

      return false;
    }

    return this.trySetItem(key, valueStr);
  }

  tryGetItem(key: string): string | null | undefined {
    if (!this.storage) return null;

    try {
      return this.storage.getItem(key);
    } catch (e) {
      window.console.warn('Uncaught: getItem error:', e);

      return null;
    }
  }

  tryGetJSONItem(key: string): object | any[] | null | undefined {
    const item = this.tryGetItem(key);

    if (typeof item !== 'string') return;

    try {
      return JSON.parse(item);
    } catch (e) {
      window.console.warn('Failed to parse value in tryGetJSONItem error:', e);

      return null;
    }
  }

  tryRemoveItem(key: string): boolean {
    try {
      if (!this.storage) return false;

      this.storage.removeItem(key);

      return true;
    } catch (e) {
      window.console.warn('Uncaught: removeItem error:', e);

      return false;
    }
  }
}
